import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from '../../../themes';

const TabsBar = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const TabButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: white;
  color: ${props => (props.active ? Theme.colors.brand : '#666')};
  border: none;
  border-bottom: 2px solid ${props => (props.isCompleted ? Theme.colors.brand : '#e0e0e0')};
  cursor: pointer;
  font-family: ${Theme.fonts.body};
  font-weight: ${props => (props.active ? 'bold' : 'normal')};
  transition: all 0.3s ease;
  text-transform: uppercase;

  &:hover {
    background: #f5f5f5;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const StepIndicator = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  transition: all 0.3s ease;

  ${props => {
    if (props.isCompleted && !props.active) {
      return `
        background: ${Theme.colors.brand};
        color: white;
      `;
    }
    if (props.active) {
      return `
        background: ${Theme.colors.brand};
        color: white;
      `;
    }
    return `
      background: #e0e0e0;
      color: #666;
    `;
  }}
`;

const CheckIcon = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${Theme.colors.brand};
`;

const TabsNavigation = ({ tabs = [], activeIndex = 0, onSelect }) => (
  <TabsBar role="tablist">
    {tabs.map((tab, idx) => {
      const isCompleted = idx < activeIndex;
      const isActive = activeIndex === idx;

      return (
        <TabButton
          key={tab?.label || idx}
          type="button"
          role="tab"
          active={isActive}
          isCompleted={isCompleted}
          aria-selected={isActive}
          data-active={isActive}
          onClick={() => onSelect(idx)}
        >
          {isCompleted ? (
            <CheckIcon className="oc-icon-check">✓</CheckIcon>
          ) : (
            <StepIndicator isCompleted={isCompleted} active={isActive}>
              {idx + 1}
            </StepIndicator>
          )}
          {tab?.label || `Tab ${idx + 1}`}
        </TabButton>
      );
    })}
  </TabsBar>
);

TabsNavigation.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
    })
  ),
  activeIndex: PropTypes.number,
  onSelect: PropTypes.func,
};

TabsNavigation.defaultProps = {
  tabs: [],
  activeIndex: 0,
  onSelect: () => {},
};

export default TabsNavigation;
